<template>
    <div
        id="modal-therapist"
        aria-hidden="true"
        aria-labelledby="modalFillInLabel"
        class="modal modal-note modal-therapist animation opacity"
        role="dialog"
        tabindex="-1"
    >
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <header class="modal-header">
                    <span class="h3">{{ __('[m] Dietitian') }}</span>

                    <button aria-hidden="true" class="close" data-dismiss="modal" type="button">
                        <svg-icon icon="close-modal" />
                    </button>
                </header>
                <div class="modal-body">
                    <div class="doctor-profile">
                        <UserAvatar v-if="coach.user" :user-info="coach.user" size="lg" />

                        <div class="doctor-info">
                            <strong class="doctor-name" v-if="coach.user">{{ coach.user | fullname }}</strong>
                            <span class="doctor-title">{{ __('[m] Dietitian') }}</span>
                            <span class="tag-verified">
                                <svg
                                    aria-hidden="true"
                                    class="svg-inline--fa fa-check fa-w-16"
                                    data-icon="check"
                                    data-prefix="fas"
                                    focusable="false"
                                    role="img"
                                    viewBox="0 0 512 512"
                                    width="28px"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
                                        fill="#00A671"
                                    ></path>
                                </svg>
                                {{ __('Verified') }}
                            </span>
                        </div>
                    </div>

                    <div class="doctor-text">
                        <p v-if="coach.about_for_doctor">{{ coach.about_for_doctor }}</p>
                        <a href="" v-if="coach.video_link">
                            <figure>
                                <iframe
                                    :src="coach.video_link"
                                    allowfullscreen=""
                                    class="embed-responsive-item doctor-video"
                                    mozallowfullscreen=""
                                    webkitallowfullscreen=""
                                ></iframe>
                            </figure>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            coach: {
                user: null,
                about_for_doctor: null,
                video_link: null
            }
        }
    },
    mounted() {
        Vuemit.listen('Patients--inspect-coach', this.onShowCoachModal)

        var that = this

        $(function() {
            $('#modal-therapist').on('hidden.bs.modal', function(e) {
                const div = document.getElementById('modal-therapist')
                const iframe = div.getElementsByTagName('iframe')[0].contentWindow
                iframe.postMessage('{"method":"pause"}', '*')

                that.coach = {
                    user: null,
                    about_for_doctor: null,
                    video_link: null
                }
            })
        })
    },
    methods: {
        onShowCoachModal(coach) {
            this.coach = coach
        }
    }
}
</script>
